import useSWR from "swr";
import { fetcher } from "@/utils";

type HexPricesResponse = {
  ehex: number | null;
  phex: number | null;
  ehexFormatted: string;
  phexFormatted: string;
};

export function useHexPrices() {
  return useSWR<HexPricesResponse>("/api/hex-prices", fetcher, {
    refreshInterval: 60_000,
  });
}
